import { getDeviceId } from './device';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.GATSBY_API_URL,
});

api.interceptors.request.use(function (config) {
  const deviceId = getDeviceId();

  config.headers['X-Client-Id'] = process.env.GATSBY_API_CLIENT_ID;
  config.headers['X-Language'] = process.env.GATSBY_API_DEFAULT_LANGUAGE;
  config.headers['X-Device-Id'] = deviceId;
  config.headers['Content-Type'] = 'application/json';

  return config;
});

export default api;
